// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import { orderStatusFormStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusForm";
import { TextFieldProps } from "@insite/mobius/TextField";
import { css } from "styled-components";

orderStatusFormStyles.form = {
    css: css`
        display: flex;
        flex-direction: column;
        @media print {
            display: none;
        }
    `,
};

orderStatusFormStyles.orderNumberTextField = {
    cssOverrides: {
        formField: css`
            width: auto;
            margin-top: 16px;
        `,
    },
    placeholder: translate("Enter Order Number"),
} as TextFieldProps;

orderStatusFormStyles.emailOrPostalCodeTextField = {
    cssOverrides: {
        formField: css`
            width: auto;
            margin-top: 16px;
        `,
    },
    placeholder: translate("Enter Email Address"),
} as TextFieldProps;

orderStatusFormStyles.submitButton = {
    css: css`
        width: auto;
        margin-top: 16px;
    `,
};
